import React, {useEffect, useState, useRef, useMemo} from 'react';
import Gravity, { MatterBody } from '../fancy/components/physics/gravity.tsx';
import { Link } from 'react-router-dom';
import Task from '../components/Task.js';

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function  getRandomSpawn(){
    console.log('innerWidth:', window.innerWidth);
    if(typeof window === 'undefined' || window.innerWidth === 0) {
        return null;
    }else if(window.innerWidth < 500){
        var x =  getRandomInt(40, 60);
        console.log('x spawn:', x);
        return x;
    }else{
        x = (getRandomInt(10, window.innerWidth)/window.innerWidth) * 100;
        if(x <= 10 || x >= 90) x = getRandomInt(15,85);
        return x;
    }
}

function newDate(nb){
    const date = new Date();
    date.setDate(date.getDate() + nb);
    return date.toISOString().split('T')[0];
}

function PageNotFound() {

    React.useEffect(() => {
        var _mtm = (window._mtm = window._mtm || []);
        _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
        var d = document,
        g = d.createElement("script"),
        s = d.getElementsByTagName("script")[0];
        g.async = true;
        g.src = "https://analytics.preprod.qalmo.fr/js/container_LnaaM1aY.js";
        s.parentNode.insertBefore(g, s);
      }, []);

    useEffect(() => {
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = originalOverflow; 
        };
    }, []);

    const cards = useMemo(() => [
        { id: 'task-1', element: <Task name="Ménage" category={1} importance={1} limitDate={newDate(-3)} isCollaborative={true}/> },
        { id: 'task-2', element: <Task name="Courses" category={0} importance={0} limitDate={newDate(-1)} isCollaborative={false}/> },
        { id: 'task-3', element: <Task name="Acheter Cadeau" category={3} importance={2} limitDate={newDate(0)} isCollaborative={true}/> },
        { id: 'task-4', element: <Task name="Appeler Banque" category={2} importance={2} limitDate={newDate(3)} isCollaborative={false}/> },
        { id: 'task-5', element: <Task name="Voyage à Saint-Malo" category={4} importance={1} limitDate={newDate(6)} isCollaborative={true}/> }
    ], []);

    const [positions, setPosition] = useState([]);
    const cardRefs = useRef(cards.map(() => React.createRef()));

    useEffect(() => {
        if (typeof window !== 'undefined' && window.innerWidth > 0) {
            const newPositions = cards.map((card) => getRandomSpawn() ?? 50);
            setPosition(newPositions);
        }
    }, [cards]);

    useEffect(() => {
        let animationFrameId;

        const checkCardsPosition = () => {
            setPosition(prevPositions => {
            let positionsChanged = false;
            const newPositions = [...prevPositions];

            cardRefs.current.forEach((ref, index) => {
                const rect = ref.current?.getBoundingClientRect();
                if (!rect) return;

                const outLeft = rect.left < -500;
                const outRight = rect.left > window.innerWidth + 500;
                const outTop = rect.top < -500;
                const outBottom = rect.top > window.innerHeight + 500;

                if (outLeft || outRight || outTop || outBottom) {
                newPositions[index] = getRandomSpawn() ?? 50;
                positionsChanged = true;
                console.log('Updating position index:', index, 'to', newPositions[index]);
                }
            });

            return positionsChanged ? newPositions : prevPositions;
            });

            animationFrameId = requestAnimationFrame(checkCardsPosition);
        };

        if (cardRefs.current.length === cards.length) {
            animationFrameId = requestAnimationFrame(checkCardsPosition);
        }

        return () => cancelAnimationFrame(animationFrameId);
    }, [cards.length]);

    if(positions.length === 0) return null;

    return (
    <div className='w-screen h-screen overflow-hidden'>
       <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center justify-center pointer-events-none z-10">
       <p className="font-fraunces text-[#000B23] text-[64px] md:text-[128px] lg:text-[256px] leading-none [text-shadow:2px_2px#ccc] md:[text-shadow:3px_3px#ccc] lg:[text-shadow:4px_4px#ccc]">404</p>
            <h1 className="font-fraunces text-2xl text-[#000B23]"> Page non trouvée </h1>
            <Link to="/">
            <button className="bg-[#000B23] text-white 
                   text-lg md:text-xl lg:text-2xl 
                   rounded-full 
                   px-5 py-2 md:px-6 md:py-3 lg:px-7 lg:py-4 
                   mt-2 pointer-events-auto">
                Retour à l'accueil
            </button>
            </Link>
        </div>
        
        <div>
            <Gravity>
            {cards.map(({ id, element }, index) => (
                <MatterBody key={id}
                    matterBodyOptions={{ friction: 0.2, restitution: 0.6 }}
                    width={300}
                    height={100}
                    x={`${positions[index]}%`}
                    y="10%">
                    <div ref={cardRefs.current[index]}>
                    {element}
                    </div>
                </MatterBody>
            ))}
            </Gravity>
        </div>
    </div>
    );
  }

export default PageNotFound;